
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }

      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Company": [
      "UserCompany",
      "PrivateCompany",
      "PublicCompany"
    ],
    "Loan": [
      "UnsecuredPersonalLoan",
      "AutoLoan",
      "HomeLoan",
      "CRELoan",
      "MemberBusinessLoan"
    ],
    "Listing": [
      "PublicListing",
      "UserCompanyListing"
    ],
    "TimelineCard": [
      "PlaceholderCard",
      "CounterpartyCard",
      "CounterpartyInsightsCard",
      "LoansCard",
      "StratificationsCard",
      "DealDocumentsCard",
      "CarveDetailsCard",
      "PlaceBidCard",
      "BidCard",
      "DiligenceCard",
      "FundingScheduleInputCard",
      "FundingScheduleDetailsCard",
      "SettlementCard",
      "WireConfirmationCard"
    ],
    "Job": [
      "PoolCreationJob",
      "OfferingCreationJob"
    ],
    "CreatePoolResult": [
      "UserCompanyListing",
      "PoolCreationJob"
    ],
    "CreatePublicOfferingResult": [
      "PublicListing",
      "OfferingCreationJob"
    ]
  }
};

      export default result;
    